npm<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Objednávky dodavatelům</h3>
              </v-flex>
            </v-layout>

            <!--<div class="">
              <router-link :to="{ path: '/dodavatele/objednavky/kontrola' }">
                <v-btn color="primary" large class="mt-3 mb-4" depressed v-if="aktualni!=null">Dokončit předchozí objednávku</v-btn>
              </router-link>
            </div>-->

            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.cislo_objednavky }}</td>
                  <td>{{ props.item.datum | formatDateFull }}</td>
                  <td>{{ props.item.vyrobce.nazev }}</td>
                  <td>
                    <span v-if="props.item.stav=='predbezna'">Předběžná</span>
                    <span v-if="props.item.stav=='objednano'">Objednáno</span>
                    <span v-if="props.item.stav=='dodano'">Dodáno</span>
                    <span v-if="props.item.stav=='zruseno'">Zrušeno</span>
                  </td>
                  <td>
                    <router-link :to="{ path: '/dodavatele/objednavky/' + props.item.id }">
                      <v-btn color="primary" class="elevation-0 ma-0" flat>
                        <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                      </v-btn>
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{ path: '/dodavatele/objednavky/' + props.item.id + '/faktura' }" v-if="props.item.stav!='predbezna' && !props.item.faktura && props.item.stav!='zruseno'">
                      <v-btn color="primary" @click="dialogPrijemka=true" class="elevation-0 ml-0" flat>
                        <v-icon small class="mr-2">add</v-icon> <span v-if="!props.item.pouze_naskladnit">Přidat fakturu</span><span v-else>Naskladnit</span>
                      </v-btn>
                    </router-link>
                    <router-link :to="{ path: '/dodavatele/objednavky/' + props.item.id + '/faktura' }" v-else-if="props.item.faktura && props.item.stav!='zruseno'">
                      <v-btn color="primary" @click="dialogPrijemka=true" class="elevation-0 ml-0" flat>
                        <v-icon small class="mr-2">receipt</v-icon> <span v-if="!props.item.pouze_naskladnit">Faktura</span><span v-else>Naskladnění</span>
                      </v-btn>
                    </router-link>
                    <!--<v-btn color="primary" @click="dialogPrijemkaSklad=true" class="elevation-0 ml-0" flat v-if="props.item.stav!='predbezna'">
                    <v-icon small class="mr-2">add</v-icon> Příjemka na sklad</v-btn>-->
                  </td>
                  <td>
                    <router-link :to="{ path: '/dodavatele/objednavky/' + props.item.id + '/prijemky' }" v-if="props.item.stav!='predbezna' && props.item.faktura && props.item.stav!='zruseno' && !props.item.pouze_naskladnit">
                      <v-btn color="primary" @click="dialogPrijemka=true" class="elevation-0 ml-0" flat>
                        <span v-if="props.item.prijemky"><v-icon small class="mr-2">list_alt</v-icon> Příjemky</span><span v-else><v-icon small class="mr-2">add</v-icon> Vytvořit příjemku</span>
                      </v-btn>
                    </router-link>
                    <!--<v-btn color="primary" @click="dialogPrijemkaSklad=true" class="elevation-0 ml-0" flat v-if="props.item.stav!='predbezna'">
                    <v-icon small class="mr-2">add</v-icon> Příjemka na sklad</v-btn>-->
                  </td>
                  <td>
                    <v-btn color="primary" class="elevation-0 ma-0" flat v-if="props.item.stav!='predbezna' && props.item.stav!='zruseno'">
                      <v-icon small class="mr-2">view_list</v-icon> Zobrazit
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <a :href="api_url + 'dodavatele/objednavky/' + props.item.id + '/pdf'" target="_blank" v-if="props.item.stav!='predbezna' && props.item.stav!='zruseno'"><v-btn color="primary" @click="dialogPDF=true" flat depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout PDF</v-btn></a>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Číslo objednávky', value: 'cislo_objednavky' },
        { text: 'Datum objednávky', value: 'datum' },
        { text: 'Dodavatel', value: 'vyrobce' },
        { text: 'Stav', value: 'stav' },
        { text: 'Akce', value: 'id' },
        { text: 'Faktura', value: 'faktura' },
        { text: 'Příjemka', value: 'id' },
        { text: 'Dokumenty dodavateli', value: 'id' },
        { text: 'PDF objednávky', value: 'id', align: 'center' }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        hlavni_cilovy_produkt_id: null,
        mena_id: null
      },
      newItem: null,
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      aktualni: null
    }
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    }
  },
  watch: {
    pagination () {
      this.load();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("dodavatele/objednavky/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.aktualni = body.aktualni;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("sporici-produkty", this.newItem).then(function(body) {
          if (body.inserted) {
            this.$router.push({path:"/sporici-produkty/"+body.data.id});
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dodavatele/ObjednavkyDodavatelum.vue